import React from "react";

const Box = ({width = "16", height = "16"}: {width?: string, height?: string}) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1216_15529)">
      <path d="M16 0H0V16H16V0Z" fill="white" fillOpacity="0.01" />
      <path
        d="M13.3333 4H2.66667C2.29848 4 2 4.29848 2 4.66667V13.3333C2 13.7015 2.29848 14 2.66667 14H13.3333C13.7015 14 14 13.7015 14 13.3333V4.66667C14 4.29848 13.7015 4 13.3333 4Z"
        stroke="#333333"
        strokeWidth="1.12281"
        strokeLinejoin="round"
      />
      <path
        d="M5.98315 8.00293H9.98315"
        stroke="#333333"
        strokeWidth="1.12281"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 4.33366L4.33333 1.66699H11.6667L14 4.33366"
        stroke="#333333"
        strokeWidth="1.12281"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1216_15529">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default React.memo(Box);
